import { useRef } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import { tailwindMerge } from '../../tailwind';

const Container = ({ className, ...props }: React.ComponentProps<'div'>) => (
  <div
    className={tailwindMerge(
      'right-zero top-l z-notification max-w-notification px-s fixed flex w-full flex-col overflow-visible',
      'desktop:right-[calc(theme(spacing.xl)_+_theme(spacing.m))] desktop:top-xl desktop:w-notification desktop:p-zero',
      className,
    )}
    {...props}
  />
);
export interface NotificationContainerProps {
  notifications: Readonly<Array<{ node: React.ReactNode; id: string }>>;
}

export const NotificationContainer = ({
  notifications,
}: NotificationContainerProps) => {
  const nodeRef = useRef(null);
  return (
    <TransitionGroup component={Container}>
      {notifications.map(({ node, id }) => (
        <CSSTransition
          timeout={500}
          key={id}
          classNames="fadeNotification"
          nodeRef={nodeRef}
        >
          <div
            ref={nodeRef}
            className={`max-h-zero pb-zero duration-medium ease-accelerate [&.fadeNotification-enter-active]:pb-s [&.fadeNotification-enter-active_>_*]:translate-x-zero [&.fadeNotification-enter-active_>_*]:ease-accelerate [&.fadeNotification-enter-done>_*]:translate-x-zero [&.fadeNotification-enter-done>_*]:ease-accelerate [&.fadeNotification-enter-done]:pb-s [&_>_*]:shadow-notification [&_>_*]:duration-medium [&_>_*]:ease-decelerate transition-all [&_>_*]:translate-x-full [&_>_*]:opacity-0 [&_>_*]:transition-all [&.fadeNotification-enter-active]:max-h-[200px] [&.fadeNotification-enter-active]:duration-[0s] [&.fadeNotification-enter-active_>_*]:opacity-100 [&.fadeNotification-enter-done]:max-h-[200px] [&.fadeNotification-enter-done]:duration-[0s] [&.fadeNotification-enter-done>_*]:opacity-100`}
          >
            {node}
          </div>
        </CSSTransition>
      ))}
    </TransitionGroup>
  );
};
